// «Настройки → Конфигуратор сайта» (подпроект 11): какие услуги каталога стоят за пунктами конфигуратора на лендинге.

/** Экран настроек (`siteConfig`). */
export const ruSiteConfig = {
  title: 'Конфигуратор сайта',
  hint: {
    title: 'Как сайт считает бюджет',
    text: 'Посетитель выбирает на сайте вид проекта и модули. Сайт складывает цены «от» услуг каталога, которые вы поставите за этими пунктами, умножает на срочность и показывает цену «От N ₽». Если у вида проекта нет услуги, сайт пишет «По запросу». Модуль без услуги просто не прибавляется',
    example:
      '«Создание сайтов» → «Корпоративный сайт» от 150 000 ₽ и «Приём платежей» → «Интеграция эквайринга» от 30 000 ₽ — сайт покажет «От 180 000 ₽»',
  },
  items: {
    title: 'Пункты сайта',
    lead: 'Для каждого пункта конфигуратора выберите услугу каталога: её цена «от» пойдёт в расчёт',
    type: 'Вид проекта',
    module: 'Модуль',
    pick: 'Выберите услугу',
    noneType: 'Не выбрано — сайт напишет «По запросу»',
    noneModule: 'Не выбрано — не прибавляется',
    missing: 'Услуга в архиве или удалена — выберите другую',
    inCabinet: 'В кабинете',
    inCabinetHint: 'Услуга видна в кабинете клиента — попадёт в его заявку',
    priceFrom: 'от {price}',
    noPrice: 'цена не считается',
    linked: '{count} из {total} пунктов с услугой',
    emptyCatalog: 'В каталоге пока нет услуг',
    emptyCatalogText:
      'Добавьте услуги в каталог — вручную или «Быстрым расчётом», тогда их можно будет выбрать здесь',
    openCatalog: 'Открыть каталог',
  },
  ai: {
    start: 'Подобрать с ИИ',
    hint: {
      title: 'Подбор с ИИ',
      text: 'ИИ читает каталог и для каждого пункта сайта выбирает подходящую услугу, с коротким объяснением. Ничего не сохраняется само: вы смотрите предложение, правите и нажимаете «Сохранить»',
      example:
        '«AI-чатбот для поддержки 24/7» → «Чат-бот на базе ИИ»: та же задача — ответы клиентам круглосуточно',
    },
    working: 'ИИ подбирает услуги…',
    cancel: 'Остановить',
    ready: 'ИИ подобрал услуги для {count} из {total} пунктов',
    apply: 'Подставить предложение',
    dismiss: 'Скрыть',
    applied: 'Предложение подставлено — проверьте и сохраните',
    failed: 'ИИ не подобрал услуги: {reason}',
    reason: 'ИИ: {reason}',
    nothing: 'ИИ: подходящей услуги нет',
  },
  multipliers: {
    title: 'Множители',
    lead: 'Срочность умножает сумму — её сайт показывает как «От N ₽». Проработанность задачи даёт верхнюю границу: её посетитель не видит, она — в заявке у менеджера',
    urgent: 'Срочный запуск',
    urgentHint: 'Запуск раньше чем через 30 дней',
    optimal: 'Оптимальный запуск',
    optimalHint: 'Запуск через 30–90 дней',
    delayed: 'Отложенный запуск',
    delayedHint: 'Запуск позже чем через 90 дней или без даты',
    ready: 'Всё продумано',
    concept: 'Есть концепция',
    idea: 'Только идея',
    unknown: 'Не выбрано',
    urgency: 'Срочность',
    spread: 'Верхняя граница для менеджера',
  },
  save: 'Сохранить',
  discard: 'Отменить правки',
  saved: 'Конфигуратор сохранён — сайт считает по-новому',
  unsaved: 'Есть несохранённые правки',
  preview: {
    title: 'Проверка',
    lead: 'Что покажет сайт на такой выбор — по сохранённым настройкам',
    type: 'Вид проекта',
    modules: 'Модули',
    launch: 'Дата запуска',
    source: 'Исходные данные',
    sourceNone: 'Не выбрано',
    result: 'Сайт покажет: от {min}',
    upper: 'Менеджеру в заявке: {min} – {max}',
    manual: 'Сайт покажет: «По запросу» — у вида проекта нет услуги',
    urgency: 'Срочность: {urgency}',
    lines: 'Из чего сложилось',
  },
} as const;

/** «История» (в `audit`). */
export const ruSiteConfigAudit = {
  actions: {
    cabinet_site: {
      changed: 'Изменён конфигуратор сайта',
    },
  },
  entities: {
    cabinet_site_settings: 'Конфигуратор сайта',
  },
  fields: {
    links: 'Услуги пунктов сайта',
    multipliers: 'Множители',
  },
} as const;
